export default {
  bindings: {
    icon: '@',
    large: '<'
  },
  template: require('../views/icon.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/icon.component.js